import React from 'react';

const SkillsSummary = () => {
    return (
        <section className="skills-summary">
            <h6 className="heading-small">
                <span>Skills and Expertise</span>
            </h6>
            <div className="section-content">
                <div className="row mt-2">
                    <div className="col skill">
                        <span className="skill-name">React JS, Redux</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'90%'}}>
                            </div>
                        </div>
                    </div>
                    <div className="col skill">
                        <span className="skill-name">REST APIs - Java (J2EE), Spring</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'55%'}}>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col skill">
                        <span className="skill-name">JavaScript - ECMAScript 6</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'85%'}}>
                            </div>
                        </div>
                    </div>
                    <div className="col skill">
                        <span className="skill-name">HTML 5, CSS 3</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'75%'}}>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col skill">
                        <span className="skill-name">Problem Solving</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'96%'}}>
                            </div>
                        </div>
                    </div>
                    <div className="col skill">
                        <span className="skill-name">Bootstrap 4</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'90%'}}>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col skill">
                        <span className="skill-name">Design Patterns - Singleton, Module and R. Module, Factory, Observer</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'75%'}}>
                            </div>
                        </div>
                    </div>
                    <div className="col skill">
                        <span className="skill-name">Angular JS</span>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped amber accent-2" style={{width:'70%'}}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default SkillsSummary;
